var initialState = {
  start: undefined,
  end: undefined,
  week1: undefined,
  week2: undefined
};
var initialStyle = {
  monthLabel: {
    fontSz: 14
  },
  box: {
    width: 40,
    fontSz: 12
  },
  calendar: {
    gap: 40
  },
  weekSeries: {
    gap: 20
  }
};

export { initialState, initialStyle };
